import React from 'react'
import './Icon.css'

const Icon = props => {
  const classNames = ['Icon']

  if(props.size) classNames.push(`is-${props.size}`)

  return (
    <span className={classNames.join(' ')}>
      <i className={`sh-icon sh-icon-${props.name}`} />
    </span>
  )
}

Icon.defaultProps = {
  name: 'info',
  size: 'normal'
}

export default Icon